// extracted by mini-css-extract-plugin
export var disabled = "styles-module--disabled--e1d0e";
export var formField = "styles-module--formField--706f4";
export var label = "styles-module--label--c15d1";
export var star = "styles-module--star--0c24f";